import React from 'react'


function Secure() {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
<rect x="0.5" y="0.5" width="99" height="99" rx="14.5" stroke="black"/>
<path d="M44 49.0007L48 53.0007L57 44.0007M66 50.0007C66 59.8176 55.2921 66.9575 51.396 69.2305C50.9532 69.4888 50.7318 69.6179 50.4194 69.685C50.1769 69.737 49.8231 69.737 49.5806 69.685C49.2682 69.6179 49.0468 69.4888 48.604 69.2305C44.7079 66.9575 34 59.8176 34 50.0007V40.4359C34 38.8369 34 38.0374 34.2615 37.3501C34.4925 36.743 34.868 36.2013 35.3553 35.7718C35.907 35.2856 36.6556 35.0049 38.1528 34.4434L48.8764 30.4221C49.2922 30.2661 49.5001 30.1882 49.714 30.1573C49.9037 30.1299 50.0963 30.1299 50.286 30.1573C50.4999 30.1882 50.7078 30.2661 51.1236 30.4221L61.8472 34.4434C63.3444 35.0049 64.093 35.2856 64.6447 35.7718C65.132 36.2013 65.5075 36.743 65.7385 37.3501C66 38.0374 66 38.8369 66 40.4359V50.0007Z" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    )
}

export default Secure